import React from 'react'
import HelpPanel from '@cloudscape-design/components/help-panel'
import Box from '@cloudscape-design/components/box'
import SpaceBetween from '@cloudscape-design/components/space-between'
import Link from '@cloudscape-design/components/link'
import Icon from '@cloudscape-design/components/icon'

/**
 * Help Panel component for the application
 * Provides support contact options
 */
const AppHelpPanel = () => {
  const supportEmail = 'wwfsidocrepo-librarian@amazon.com'
  const simUrl = 'https://sim.amazon.com/issues/create?assignedFolder=KMSDID-LIBRARIAN'
  const docRepoUrl = 'https://amazongbr.sharepoint.com/sites/FSIDocRepo'

  return (
    <HelpPanel
      header={<h2>Get Help</h2>}
      footer={
        <Box textAlign="center" color="text-body-secondary" fontSize="body-s">
          <Box variant="p">
            For urgent issues, please email the support team directly.
          </Box>
        </Box>
      }
    >
      <SpaceBetween size="l">
        <Box variant="p">
          Need assistance with the WW FSI Document Management application? 
          Choose one of the support options below:
        </Box>

        <SpaceBetween size="m">
          <Box>
            <Box variant="h3" padding={{ bottom: 'xs' }}>
              <Icon name="envelope" /> Email Support
            </Box>
            <Box variant="p" padding={{ bottom: 's' }}>
              Send an email to the support team for general questions, 
              feature requests, or non-urgent issues.
            </Box>
            <Link
              external
              href={`mailto:${supportEmail}?subject=KMSDID Support Request`}
              variant="primary"
            >
              Email {supportEmail}
            </Link>
          </Box>

          <Box>
            <Box variant="h3" padding={{ bottom: 'xs' }}>
              <Icon name="ticket" /> Create SIM Ticket
            </Box>
            <Box variant="p" padding={{ bottom: 's' }}>
              Create a SIM ticket for bug reports, access requests, 
              or issues that require tracking.
            </Box>
            <Link
              external
              href={simUrl}
              variant="primary"
            >
              Create SIM Ticket
            </Link>
          </Box>

          <Box>
            <Box variant="h3" padding={{ bottom: 'xs' }}>
              <Icon name="external" /> WWFSI DocRepo Website
            </Box>
            <Box variant="p" padding={{ bottom: 's' }}>
              Visit the WWFSI Document Repository SharePoint site for 
              additional resources and documentation.
            </Box>
            <Link
              external
              href={docRepoUrl}
              variant="primary"
            >
              Open WWFSI DocRepo
            </Link>
          </Box>
        </SpaceBetween>

        <Box>
          <Box variant="h3" padding={{ bottom: 'xs' }}>
            Common Support Requests
          </Box>
          <ul style={{ paddingLeft: '20px', margin: '8px 0' }}>
            <li>Request librarian access</li>
            <li>Report a bug or issue</li>
            <li>Request a new feature</li>
            <li>Report incorrect data</li>
            <li>Get help with CSV import</li>
          </ul>
        </Box>

        <Box>
          <Box variant="h3" padding={{ bottom: 'xs' }}>
            What to Include
          </Box>
          <Box variant="p">
            When contacting support, please include:
          </Box>
          <ul style={{ paddingLeft: '20px', margin: '8px 0' }}>
            <li>Your username</li>
            <li>Description of the issue</li>
            <li>Steps to reproduce (if applicable)</li>
            <li>Any error messages</li>
            <li>Screenshots (if helpful)</li>
          </ul>
        </Box>

        <Box>
          <Box variant="h3" padding={{ bottom: 'xs' }}>
            Documentation
          </Box>
          <Box variant="p">
            Check the user guide for answers to common questions and 
            step-by-step instructions.
          </Box>
        </Box>
      </SpaceBetween>
    </HelpPanel>
  )
}

export default AppHelpPanel
